import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const BoldIcon = ({ color = '#798588', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.24 12.155v5.143h2.529c1.787 0 3.047-.197 3.777-.59.731-.394 1.096-1.051 1.096-1.973 0-.933-.348-1.597-1.045-1.99-.697-.394-1.917-.59-3.66-.59H6.24zm8.6-1.872c1.225.45 2.125 1.065 2.698 1.846.573.782.86 1.78.86 2.994a5.43 5.43 0 0 1-.742 2.799c-.495.843-1.203 1.535-2.125 2.074a6.031 6.031 0 0 1-1.813.683c-.669.14-1.616.211-2.841.211H2.074c-.742 0-1.273-.146-1.593-.438-.32-.293-.481-.77-.481-1.434 0-.596.152-1.048.455-1.357.304-.31.748-.464 1.333-.464h.286V4.617h-.286c-.585 0-1.03-.158-1.333-.472C.152 3.83 0 3.369 0 2.762c0-.652.163-1.127.489-1.425.326-.298.854-.447 1.585-.447h7.757c2.372 0 4.174.46 5.405 1.383 1.231.922 1.847 2.27 1.847 4.047 0 .877-.189 1.65-.565 2.319-.377.669-.936 1.217-1.678 1.644zm-8.6-5.767v4.25h2.276c1.383 0 2.358-.164 2.926-.49.568-.326.851-.877.851-1.652 0-.731-.255-1.265-.767-1.602-.511-.338-1.34-.506-2.487-.506h-2.8z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

BoldIcon.propTypes = propTypes;

export default BoldIcon;
